module.exports = __webpack_public_path__ + "img/jin_01.feb8240f.png";